export default __webpack_public_path__ + "static/media/arrow.58d85f1d.png";